module.exports = __webpack_public_path__ + "static/media/OnSignup100.30bd5b69.png";